var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83923 12.7385C5.29056 15.6171 11.0592 15.6171 13.5105 12.7385C15.7684 10.0871 15.5971 4.89745 12.8795 2.62751C10.4454 0.594298 5.90443 0.594298 3.4703 2.62751C0.752755 4.89745 0.581392 10.0871 2.83923 12.7385Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83923 12.7385C5.29056 15.6171 11.0592 15.6171 13.5105 12.7385C15.7684 10.0871 15.5971 4.89745 12.8795 2.62751C10.4454 0.594298 5.90443 0.594298 3.4703 2.62751C0.752755 4.89745 0.581392 10.0871 2.83923 12.7385Z",
    fill: "#B6C0F3",
    stroke: "#313B6B",
    strokeWidth: 1.144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 4.914V8.56389V4.914Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 4.914V8.56389",
    stroke: "#313B6B",
    strokeWidth: 1.144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 10.4277V11.0863V10.4277Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 10.4277V11.0863",
    stroke: "#313B6B",
    strokeWidth: 1.144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.174316)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.56cf21cf0a54a8941d8ad6a13bb5c9ef.svg";
export { ForwardRef as ReactComponent };